import { h } from 'preact';
import { ANNOTATION_EVENT } from 'constants/events';
import { alphabeticOrdinal } from 'utilities/list';
import { PopAnnotation } from 'rendering/annotations/pop';

export const PostSubmitMessages = ({
    displayed = false,
    messages = [],
    styles = {}
}) => {
    const rootAttrs = {
        className: 'postSubmitMessages'
    }

    if (!displayed) {
        rootAttrs.style = {
            display: 'none'
        }
    }

    return (
        <div {...rootAttrs}>
            {
                messages.map((m,i) => 
                    <PopAnnotation
                        {...m}
                        key={`message-${i}`}
                        styles={{
                            ...styles,
                            display: m.mode === 'invisible' ? 'none' : 'block'
                        }}
                    />
                )
            }
        </div>
    )
}

export const NewselaReviewScreen = ({
    quizId,
    eventBus,    
    displayed = false,
    numQuestions = 0,
    answers = {},
    questions = [],
    answeredCorrectly = [],
    answeredIncorrectly = [],
}) => {
    const toQuestion = id => e => {
        e.preventDefault();
        eventBus.emit(ANNOTATION_EVENT.NAVIGATE_SUB_ELEMENT, {
            id: quizId,
            path: [id]
        })
    };

    if (!displayed) {
        return null;
    }

    return (
        <div className="reviewScreen">
            <div className="summary">
                <h4>
                    {answeredCorrectly.length} of {numQuestions} Correct
                </h4>
            </div>
            <div className="evaluation">
                <ul>
                {
                    questions.map((q,i) => {
                        const wasCorrectlyAnswered = answeredCorrectly.includes(q.id);
                        const answeredIndex =  q.answers.findIndex(a => a.properties?.value === answers[q.id]);
                        const correctIndex = q.correctAnswerIndex;

                        return (
                            <li className="questionSummary">
                                <div
                                    aria-hidden="true"
                                    className="evaluationLabel"
                                    data-correct={wasCorrectlyAnswered ? "true" : "false"}
                                />
                                <div className="evaluationDetails">
                                    <h5 className="question">Question {i+1}: {wasCorrectlyAnswered ? 'Correct' : 'Incorrect'}</h5>
                                    <p>
                                        {
                                            wasCorrectlyAnswered ? 
                                                `You chose ${alphabeticOrdinal(answeredIndex)}, the correct answer` :
                                                `The correct answer is ${alphabeticOrdinal(correctIndex)}. You chose ${alphabeticOrdinal(answeredIndex)}`
                                        }
                                    </p>
                                    <div className="reviewButton">
                                        <button onClick={toQuestion(q.id)}>Review Question {i+1}</button>
                                    </div>                                    
                                </div>                                
                            </li>
                        )
                    })
                }
                </ul>
            </div>
        </div>
    )
}